export default "__VITE_ASSET__CwZOFVJs__"